import { Injectable } from '@angular/core';
import { ValueFormatterParams } from '@ag-grid-community/core';

@Injectable({
  providedIn: 'root'
})
export class GridUtilitiesService {

  constructor() { }

  // private formatTimestamp_(params: ValueFormatterParams): string {
  timestampValueFormatter(params: ValueFormatterParams): string {
    const timestamp = params.value;
    return timestamp ? new Date(timestamp).toLocaleString() : '';
  }

  timestampFilterComparator(filterLocalDateAtMidnight: Date, cellValue: number): -1 | 0 | 1 {
    if (cellValue == null) {return -1;}
    const nextDayAtMidnight = filterLocalDateAtMidnight.getTime() + (1000 * 60 * 60 * 24);
    const cellDate = new Date(cellValue);

    // At or after midnight, and before midnight the following day
    if (filterLocalDateAtMidnight.getTime() <= cellDate.getTime() && cellDate.getTime() < nextDayAtMidnight) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
  }
}
